module.exports = __webpack_public_path__ + "img/_54A2242_t.18d4c3af.jpg";